import React from 'react';
import SiteContentContext from '../../content/SiteContentContext';
import { getTranslations, getByPath, resolveMediaSrc } from '../../content/siteContentUtils';

var bgimg1 = require('./../../images/background/bg5.jpg');

class About2 extends React.Component {
    static contextType = SiteContentContext;

    render() {
        const content = this.context?.content || {};
        const t = getTranslations(content);
        const intro = t?.pages?.about?.intro || {};
        const introImage = resolveMediaSrc(getByPath(content, 'media.pages.aboutIntroImage', ''), bgimg1);

        return (
            <>
                <div className="section-full mobile-page-padding p-t80 p-b80 bg-gray">
                    <div className="container">
                        <div className="section-content">
                            <div className="row">
                                <div className="col-xl-5 col-lg-5 col-md-12 ">
                                    <div
                                        className="home-2-about bg-bottom-left bg-no-repeat"
                                        style={{ backgroundImage: 'url(' + introImage + ')', backgroundSize: 'contain' }}
                                    >
                                    </div>
                                </div>
                                <div className="col-xl-7 col-lg-7 col-md-12">
                                    <div className="about-home-2">
                                        <h3 className="m-t0 sx-tilte">{intro.title}</h3>
                                        <p>{intro.description}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default About2;
